<template>
  <div class="login-container">
    <div class="title_content" style="justify-content: space-between;display: flex;width: 90%;">
      <div class="login_logo">
        <img class="shiji" src="../../assets/images/shiji payment logo.png" />

        <!-- <span class="title_text" :class="[language === 'cn' ? 'letter' : '']">{{
          $t("login.title")
        }}</span> -->
      </div>

      <div>
        <a @click="changeLanguage" style="font-size:16px;font-weight: 400;" target="_Blank" class="forgetPwd">{{ content }}</a>
        <!--<lang-select class="right-menu-item hover-effect"/>-->

        <!--language==='cn'" command="cn">-->
        <!--中文-->
        <!--</el-dropdown-item>-->
        <!--<el-dropdown-item :disabled="language==='en'-->
      </div>
    </div>
    <div class="main-content">
      <el-form class="login-form" autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left">
        <el-tabs class="tabs" v-model="activeTabs">
          <el-tab-pane name="first">
            <span slot="label" class="pane1">
              <span class="svg-container svg-container_login">
                <svg-icon icon-class="user" />
              </span>
              {{ $t("login.accounts_pass_login") }}</span>
            <div class="mar-10">
              <el-form-item prop="userCode" class="item-form">
                <span class="svg-container svg-container_login">
                  <svg-icon icon-class="people_fill" />
                </span>
                <el-input name="userCode " clearable type="text" v-model.trim="loginForm.userCode" autoComplete="on"
                  v-bind:placeholder="$t('login.username_placeholder')" maxlength="100" />
              </el-form-item>
              <el-form-item prop="encUserPWD" class="item-form">
                <span class="svg-container svg-container_login">
                  <svg-icon icon-class="password"></svg-icon>
                </span>
                <el-input name="encUserPWD" :type="pwdType" @keyup.enter.native="handleLogin" v-model.trim="loginForm.encUserPWD" autoComplete="on"
                  v-bind:placeholder="$t('login.password_placeholder')" maxlength="100"></el-input>
                <span class="show-pwd" @click="showPwd">
                  <svg-icon :icon-class="pwdType === 'password' ? 'eye-open' : 'eye'" />
                </span>
              </el-form-item>

              <!--<el-form-item prop="appCode " class="item-form">-->
              <!--<span class="svg-container svg-container_login">-->
              <!--<svg-icon icon-class="validCode"></svg-icon>-->
              <!--</span>-->
              <!--<el-input-->
              <!--name="userCode "-->
              <!--type="text"-->
              <!--v-model.trim="loginForm.verifyCode"-->
              <!--autoComplete="on"-->
              <!--v-bind:placeholder="$t('login.verifyCode_placeholder')"-->
              <!--maxlength="4"-->
              <!--/>-->
              <!--</el-form-item>-->

              <el-button type="smalt" style="width:100%;" :loading="loading"
                @click.native.prevent="handleLogin">
                {{ $t("login.loginBtn") }}
              </el-button>
              <div class="item4">
                <el-checkbox size="medium" v-model="rememberFlag">{{ $t("login.remember") }}
                </el-checkbox>
                <!--href="https://www.shijigroup.com/"-->
                <!-- 暂时关闭注册入口 -->
                <!-- <a style="font-size: 14px;" @click="handleRegister" target="_Blank" class="register">
                  {{ $t("login.register") }}</a> -->
                <a style="font-size: 14px;" @click="handlePwd" target="_Blank" class="forgetPwd">
                  {{ $t("login.forget_pass") }}</a>
              </div>

            </div>
            <div style="font-size:11px;">
              <span style="width:100%;text-align: center;display: flex;align-items: center;"><span
                  style="color:#b7b7b7;">————————————————————</span>其他登录方式<span style="color:#b7b7b7;">————————————————————</span></span>
            </div>
            <div class="item4" style="padding: 0px 10px;justify-content: flex-start;">
              <div v-if="loginSource == 'marriot'">
              <img  alt="" title="万豪" style="cursor: pointer;" @click="toMarriott()" width="45" height="45" src="@/assets/images/marriott.png">
              </div>
              <div v-else-if="loginSource === 'LLSHR_Pay' || loginSource === 'LLSHR_PayTEST'">
              <img  alt="" title="乐高" style="cursor: pointer;margin-left:20px;" @click="toLLSHR()" width="45" height="45" src="@/assets/images/legao.jpg">
              </div>
               <div v-else>
                <img  alt="" title="万豪" style="cursor: pointer;" @click="toMarriott()" width="45" height="45" src="@/assets/images/marriott.png">
                <!-- <img  alt="" title="乐高" style="cursor: pointer;margin-left:20px;" @click="toLLSHR()" width="45" height="45" src="@/assets/images/legao.jpg"> -->
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="second">
            <span slot="label" class="pane2">
              <span class="svg-container svg-container_login">
                <svg-icon icon-class="qrcode" /> </span>扫码快速登录</span>
            <div>
              <div class="login_d">
                <div class="qrcode" ref="qrCodeUrl"></div>
                <!-- <div
                  class="ms-login qrcode" ref="qrCodeUrl"
                  style="display: flex;align-items: center;justify-content: center;"
                >
                  二维码
                </div> -->
              </div>

            </div>
          </el-tab-pane>
          <!--<el-tab-pane name="second">-->
          <!--<span slot="label" class="pane2">-->
          <!--<span class="svg-container svg-container_login">-->
          <!--<svg-icon icon-class="qrcode"/> </span-->
          <!--&gt;{{$t('login.scan_code_login')}}</span-->
          <!--&gt;-->
          <!--<div>-->
          <!--<div class="login_d">-->
          <!--<div-->
          <!--class="ms-login"-->
          <!--style="display: flex;align-items: center;justify-content: center;"-->
          <!--&gt;-->
          <!--二维码-->
          <!--</div>-->
          <!--</div>-->

          <!--</div>-->
          <!--</el-tab-pane>-->
        </el-tabs>
      </el-form>
    </div>

    <div class="footer">
      <div class="tips">
        <p class="link">
          Copyright © 2021-2025<a href="https://www.shijigroup.com/" target="_Blank">
            shijigroup</a>. All rights reserved
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../store";
import { SHA256 } from "@/utils/jsonSha256";
import LangSelect from "@/components/LangSelect";
import Cookies from "js-cookie";
import { setUserCode } from "@/utils/auth";
import { Alert, Message, MessageBox, Notification } from "element-ui";
import QRCode from "qrcodejs2";

export default {
  name: "login",
  components: {
    LangSelect,
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (
        rule.required === true &&
        (value === "" || value === null || value === undefined)
      ) {
        callback(new Error(this.$t("login.username_placeholder")));
      } else if (value.length == 0) {
        callback(new Error(this.$t("login.username_invaild")));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (
        rule.required === true &&
        (value === "" || value === null || value === undefined)
      ) {
        callback(new Error(this.$t("login.password_placeholder")));
      } else if (value.length < 6) {
        callback(new Error(this.$t("login.password_invaild")));
      } else {
        callback();
      }
    };

    return {
      activeTabs: "first",
      // imgPrefix: process.env.BASE_API + "/user/getVerify?" + Math.random(),
      loginForm: {
        userCode: "",
        encUserPWD: "",
      },
      content: this.$i18n.locale === "cn" ? "Switch English" : "切换中文",
      flag: true,
      style: "",
      style1: "display:none;",
      loginRules: {
        userCode: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        encUserPWD: [
          { required: true, trigger: "blur", validator: validatePass },
        ],
      },
      loading: false,
      pwdType: "password",
      rememberFlag: false,
    };
  },

  computed: {
    language() {
      return this.$store.getters.language;
    },
    loginSource() {
      return this.$store.getters.loginSource;
    },
  },

  created() {
    this.getCookie();
  },
  mounted() {
    this.creatQrCode();
  },
  methods: {
    getCookie() {
      const rememberFlag = Cookies.get("rememberFlag");
      this.rememberFlag =
        rememberFlag === undefined ? false : Boolean(rememberFlag);
      const userCode = Cookies.get("userCode");
      const userPwd = Cookies.get("userPwd");
      if (this.rememberFlag) {
        this.loginForm = {
          userCode: userCode === undefined ? this.loginForm.userCode : userCode,
          encUserPWD:
            userPwd === undefined ? this.loginForm.encUserPWD : userPwd,
        };

        if (this.loginForm.userCode && this.loginForm.encUserPWD) {
          this.onLogin();
        }
      }
    },
    handleRegister() {
      // 暂时关闭注册入口
      this.$router.push({ path: "/register" });
    },
    handlePwd() {
      this.$router.push({ path: "/resetPwd" });
    },

    showPwd() {
      if (this.pwdType === "password") {
        this.pwdType = "";
      } else {
        this.pwdType = "password";
      }
    },
    changeLanguage() {
      if (this.$i18n.locale === "cn") {
        this.$i18n.locale = "en";
        this.content = "切换中文";
        this.$store.dispatch("setLanguage", this.$i18n.locale);
        this.$message({
          message: "Switch English Success",
          type: "success",
        });
      } else {
        this.$i18n.locale = "cn";
        this.content = "Switch English";
        this.$store.dispatch("setLanguage", this.$i18n.locale);
        this.$message({
          message: "切换中文成功",
          type: "success",
        });
      }
    },
    handleLogin() {
        console.log("loginSorce", store.getters.loginSource);
      let _that = this;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // let userPwd = _that.loginForm.userCode + _that.loginForm.encUserPWD;
          // this.loginForm.encUserPWD = SHA256(userPwd);
          // console.log("loginForm", this.loginForm);
          if (this.rememberFlag) {
            Cookies.set("userCode", this.loginForm.userCode, { expires: 30 });
            Cookies.set("userPwd", this.loginForm.encUserPWD, { expires: 30 });
            Cookies.set("rememberFlag", this.rememberFlag, { expires: 30 });
          } else {
            Cookies.remove("userCode");
            Cookies.remove("userPwd");
            Cookies.remove("rememberFlag");
          }
          this.onLogin();
        } else {
          return false;
        }
      });
    },
    creatQrCode() {
      // console.log(window.document.location.href)
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: window.document.location.href, // 需要转换为二维码的内容
        width: 180,
        height: 180,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    onLogin() {
      let _that = this;

      appId: "000001";
      encUserPWD: "e956c408335635c4235ce4305840456cb99c2b71c76a5024feca08ec1a248d60";
      sign: "60052dcdee39122eb9d3eff0ff2d1022932d7a4392651de94ac76adb398fc806";
      txnReqTime: "2022/06/24-16:54:23";
      userCode: "10001";

      let loginForm = {
        encUserPWD: this.loginForm.encUserPWD,
        userCode: this.loginForm.userCode,
      };
      this.$store
        .dispatch("user/login", loginForm)
        .then((response) => {
          this.loading = false;
          setUserCode(_that.loginForm.userCode);
          if (response.respCode == "X5") {
            //初始化密码修改
            this.$router.push({ path: "/initPwd" });
          } else {
            if (response.respCode == "00") {
              // console.log("77777777777777777:"+response.subRespCode)
              this.$router.push({ path: "/home" });
            } else {
              this.loginForm.encUserPWD = "";
              Notification.error({
                title: response.respDesc,
              });
              this.$router.push({ path: "/login" });
            }
          }
        })
        .catch(() => {
          this.loading = false;
          this.loginForm.encUserPWD = "";
        });
    },
    toMarriott() {
      location.href = process.env.MARROITT_URL;
    },
    toLLSHR() {
      location.href = process.env.LLSHR_URL;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
$bg: #fff;
$light_gray: #eee;
$height: 35px;

/* reset element-ui css */
.login-container {
  .el-select {
    display: inline-block;
    height: $height; //height: 40px;
    /*width: 85%;*/
  }

  .el-input {
    display: inline-block;
    height: $height; //height: 40px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      /*padding: 12px 5px 12px 15px;*/
      color: #2c2c2c;
      height: $height; //height: 40px;

      &:-webkit-autofill {
        -webkit-animation: autofill-fix 1s infinite;
        -webkit-text-fill-color: #2c2c2c;
        -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
      }

      @-webkit-keyframes autofill-fix {
        from {
          background-color: transparent;
        }
        to {
          background-color: transparent;
        }
      }
    }
  }

  .el-form-item {
    border-bottom: 1px solid #eee;
    background: $bg;
    border-radius: 50px;
    /*color: #454545;*/
    margin-bottom: 30px;
  }
}

.item-form .el-form-item__content {
  line-height: 10px;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.login_logo {
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
}

.shiji {
  height: 40px;
  // width: 129px;
  margin-left: 20px;
  /* vertical-align: super; */
  /*vertical-align: 6px;*/
}

.title_text {
  font-size: 20px;
  padding: 0 10px;
  font-family: AdobeHeitiStd-Regular, AdobeHeitiStd;
  /*letter-spacing: 3px;*/
  line-height: 50px;
  font-weight: 600;
}

.letter {
  letter-spacing: 1px;
}

.el-dropdown {
  font-size: 18px;
}

.el-button {
  font-size: 14px;
}

.el-input__inner,
.el-radio__label {
  font-size: 14px;
}

.l-login-weixin {
  position: absolute;
  right: 42px;
  top: 30px;
}

.l-login-weixin img {
  width: 52px;
  height: 52px;
}

.login-code {
  width: 40%;
  height: 35px;
  float: right;

  img {
    cursor: pointer;
  }
}

.login-code-img {
  height: 35px;
}

.login-container::before {
  z-index: -999;
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  // background-image: url("../../assets/images/login5.jpg");
  background-size: cover;
}

.main-content {
  width: 100%;
  height: 875px;
  margin-top: 50px;
  // height: 100%;
  background-image: url("../../assets/images/login_bg.png");
  background-size: cover;
}

$bg: #ffffff;
$dark_gray: #eee;
$light_gray: #eee;
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: $bg;

  .title_content {
    height: 50px;
    font-size: 35px;
    font-weight: 700;
    color: #000000;
    // width: 100%;
    // font-style: italic;
    /*line-height: 90px;*/
    // font-family: fangsong;
    position: absolute;
    left: 5%;
    top: 0;
    /*margin: 20px 0 0 0;*/
  }

  .login-form {
    /*position: absolute;*/
    /*left: 0;*/
    /*right: 0;*/
    /*width: 375px;*/
    /*padding: 35px 35px 15px 35px;*/
    /*margin: 120px auto;*/

    position: absolute;
    right: 0%;
    top: 50%;
    width: 508px;
    @media screen and (min-width: 100px) {
      margin: -250px -35px 0 0;
    }
    @media screen and (min-width: 720px) {
      margin: -250px 250px 0 0;
    }
    // border-radius: 5px;
    /*background: rgba(255, 255, 255, 0.3);*/
    background: #fff;
    overflow: hidden;
    // padding: 0 30px;
    -moz-box-shadow: 10px 10px 5px rgba(255, 255, 255, 0.1); /* 老的 Firefox */
    box-shadow: 10px 10px 5px rgba(255, 255, 255, 0.1);
    height: 440px;
  }

  .language_change {
    /*position: absolute;*/
  }

  .tips {
    font-size: 18px;
    color: #fff;
    /*margin-bottom: 10px;*/

    span {
      float: right;

      &:first-of-type {
        margin-right: 16px;
      }

      cursor: pointer;
    }

    .link {
      font-size: 14px;
      text-align: center;
      color: #9fa3ab;

      a {
        color: var(--menu-active-text);
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    margin-right: 5px;
    color: #909399;
    vertical-align: middle;
    width: 35px;
    display: inline-block;
    &_login {
      font-size: 13px;
    }
  }

  .title {
    font-size: 25px;
    /*color:#fff;*/
    color: #000000;
    /*margin: 0px auto 30px auto;*/
    position: relative;
    /*text-align: center;*/
    font-weight: bold;
    width: 80%;
    line-height: 90px;

    .language_change {
      position: absolute;
      right: 0;
      color: white;
      font-size: 16px;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}

.login_d {
  width: 200px;
  height: 200px;
  border: 1px solid #e2e2e2;
  padding: 10px;
  border-radius: 4px;
  margin: 40px auto 40px;
}

.mar-10 {
  margin-top: 65px;
  padding: 0px 60px;
}

.tabs /deep/ .el-tabs__nav {
  width: 90% !important;
}

.tabs /deep/ .el-tabs__active-bar {
  background-color: var(--menu-active-text) !important;
  width: 107% !important;
}

.tabs /deep/ .el-tabs__item {
  padding: 10px !important;
  text-align: center !important;
  width: 100% !important;
  font-size: 16px !important;
  height: 63px !important;
}

.item4 /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: var(--menu-active-text) !important;
  border-color: var(--menu-active-text) !important;
}

.item4 /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: var(--menu-active-text) !important;
}

.item4 /deep/ .el-checkbox__inner:hover {
  border-color: var(--menu-active-text) !important;
}

.pane1 {
  color: var(--menu-active-text);
}

.pane2 {
  padding-left: 10% !important;
  color: var(--menu-active-text);
}

.svg-icon {
  width: 1.5em !important;
  height: 1.5em !important;
}

.footer {
  position: absolute; // 关键
  bottom: 0;
  left: 0;
  right: 0;
  height: 35px; // 设置固定高度
  background-color: #fff;
  line-height: 10px;
}

.item4 {
  display: flex;
  margin: 10px 15px;
  justify-content: space-between;
}

.el-checkbox__inner {
  width: 17px;
  height: 17px;
}

.el-checkbox__label {
  font-size: 17px;
}

.forgetPwd:hover {
  text-decoration: underline;
  color: #1D4ED8;
}
.register:hover {
  text-decoration: underline;
  color: var(--menu-active-text);
}
.qrcode {
  display: inline-block;
  img {
    width: 132px;
    height: 132px;
    background-color: #fff; //设置白色背景色
    padding: 6px; // 利用padding的特性，挤出白边
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue